import { useTranslation } from 'react-i18next'

import { Divider, Switch, Text } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'

import * as Styles from './styles'

const SkipRefundMethodStep = ({
  allowedPreferences,
  skipSingleRefundMethodStep,
  onChangeSkipSingleRefundMethodStep,
}) => {
  const { t } = useTranslation()

  const handleChange = e => onChangeSkipSingleRefundMethodStep(e.target.checked)

  if (!allowedPreferences.includes(preferences.skipSingleRefundMethodStep)) return null

  return (
    <>
      <Divider />
      <Styles.Container>
        <Text type="titleS">{t('Saltar el paso de método de reembolso')}</Text>
        <Text type="bodyMRegular">
          {t(
            'Ahorra un paso a tus clientes: si solo hay un método de reembolso disponible, se aplica automáticamente y lo verán en el resumen.'
          )}
        </Text>
        <Switch
          label={<Text type="bodyMBold">{t('Saltar el paso si solo hay un método de reembolso disponible')}</Text>}
          checked={skipSingleRefundMethodStep}
          onChange={handleChange}
        />
      </Styles.Container>
    </>
  )
}

export default SkipRefundMethodStep
